<template>
  <article class="user-info">
    <div class="user-avatar">
      <avatar :user="user" :border="false" />
    </div>
    <div>
      <div class="user-role">
        {{ roleName }}
      </div>
      <div class="user-name">
        {{ user.name }}
      </div>
    </div>
  </article>
</template>

<script>
  import Avatar from '@/components/administrator/work-shift/staff/Avatar'

  export default {
    name: 'UserInfoLabel',
    components: { Avatar },
    props: {
      user: Object,
    },
    computed: {
      roleName () {
        return this.user?.roles[0]?.title
      },
    },
  }
</script>

<style lang="less" scoped>
.user-info {
    display: flex;
    align-items: center;
    }

  .user-avatar {
    width: 59px;
    height: 59px;
    border-radius: 50%;
    background: #fff;
    // роль и имя начинаются с одной вертикали с «Заказ №…»
    margin-right: 24px;
    font-size: 2.7em;

    ::v-deep {
      .avatar {
        width: 59px;
        height: 59px;
      }
    }
  }
.user-role {
    line-height: 1;
    font-size: 14px;
    color: #262626;
}

.user-name {
    font-weight: bold;
    font-size: 18px;
    color: #262626;
    letter-spacing: 0.4px;
  }
</style>
